
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"warning.incompatible-selection":"Die Auswahl kann keine Objekte aus verschiedenen Layer enthalten.","info.filteringApplied":"Auswahl als Filter für die Arbeitsmappe angewendet"},"en":{"warning.incompatible-selection":"Selections cannot contain objects of different layers.","info.filteringApplied":"Selection applied as filter for workbook"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();